(function (global) {
  var COOKIE_AGE = '1925_age_verified';
  var COOKIE_INTRO = '1925_intro_seen';

  function hasCookie(name) {
    return new RegExp('(?:^|; )' + name + '=1(?:;|$)').test(document.cookie);
  }

  function setCookie(name, days) {
    var maxAge = (parseInt(days, 10) || 30) * 24 * 60 * 60;
    document.cookie = name + '=1; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  global.Nineteen25Flow = {
    COOKIE_AGE: COOKIE_AGE,
    COOKIE_INTRO: COOKIE_INTRO,
    hasAgeVerified: function () {
      return hasCookie(COOKIE_AGE);
    },
    hasIntroSeen: function () {
      return hasCookie(COOKIE_INTRO);
    },
    setAgeVerified: function (days) {
      setCookie(COOKIE_AGE, days);
    },
    setIntroSeen: function (days) {
      setCookie(COOKIE_INTRO, days);
    },
  };
})(window);
